@if(pageInfo?.['title'] != 'Analytical' && pageInfo?.['title'] != 'eCommerce' && pageInfo?.['title'] != 'Chat'){
<div class="bg-light-primary rounded p-y-12 p-x-24 m-b-20 overflow-hidden">
  <div class="row">
    <div class="col-sm-8">
      <h4 class="page-title m-0 f-s-20 f-w-600 m-b-16">
        {{ pageInfo?.['title'] | localize }}
      </h4>
    </div>
<!--    <div class="col-sm-4 text-right position-relative">-->
<!--      <div class="breadcrumb-icon">-->
<!--        <img-->
<!--          src="/assets/images/breadcrumb/ChatBc.png"-->
<!--          alt="breadcrumb"-->
<!--          width="165"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->
  </div>
</div>
}
